import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Text } from '@fiverr-private/typography';
import { ArrowRightIcon } from '@fiverr-private/visuals';
import { Box } from '@fiverr-private/theme';

export interface FirstTimeComplianceCardProps {
    isCompact?: boolean;
    onClick: () => void;
    icon: React.ReactNode;
    title: string;
    ctaText: string;
    containerStyles?: Partial<React.ComponentProps<typeof Box>>;
}

export const FirstTimeComplianceCard = ({
    isCompact,
    onClick,
    icon,
    title,
    ctaText,
    containerStyles,
}: FirstTimeComplianceCardProps) => (
    <Box
        paddingY="1"
        borderRadius="lg"
        borderColor="grey_400"
        borderWidth="sm"
        borderStyle="solid"
        width={'100%'}
        overflow="hidden"
        boxShadow={{
            hover: 'z1',
        }}
        cursor="pointer"
        onClick={onClick}
        {...containerStyles}
    >
        <Stack
            direction="row"
            alignItems="center"
            paddingX="4"
            paddingY="2"
            gap="2"
            justifyContent="spaceBetween"
            width="100%"
        >
            <Stack direction="row" gap="2" alignItems="center">
                {icon}
                <Stack gap="1">
                    {isCompact && (
                        <Text size="b_sm" fontWeight="semibold">
                            {ctaText}
                        </Text>
                    )}
                    <Text size="b_sm" fontWeight="semibold">
                        {title}
                    </Text>
                </Stack>
            </Stack>
            <ArrowRightIcon size="sm" color={'grey_1200'} />
        </Stack>
    </Box>
);
